export default __webpack_public_path__ + "static/media/IELTSS.bfaf741e.png";